import { deserializeUser } from "./util/Serialization";
import { FieldValue } from "@/data/Firebase";
import { IllegalArgumentException } from "@/shared/IllegalArgumentException";
import { doc } from "rxfire/firestore";
import { map } from "rxjs/operators";
import { mapUserToDb } from "@/data/model/DbUser";
export class UserRepositoryImpl {
    constructor(db) {
        this.db = db;
        this.usersCollection = this.db.collection("users");
    }
    async getUsers() {
        const snapshot = await this.usersCollection.get();
        return snapshot.docs.map(doc => deserializeUser(doc.id, doc.data()));
    }
    async findUserByUsername(username) {
        const snapshot = await this.getDocumentByField("username_lowercase", username.toLowerCase());
        return toUser(snapshot);
    }
    async findUserByEmail(email) {
        const snapshot = await this.getDocumentByField("email", email.toLowerCase());
        return toUser(snapshot);
    }
    findUserById(id) {
        return doc(this.usersCollection.doc(id)).pipe(map(toUser));
    }
    addUser(userId, user) {
        const doc = this.usersCollection.doc(userId);
        const dbUser = mapUserToDb(user);
        return doc.set(dbUser).then(() => { });
    }
    async updateUser(id, change) {
        const doc = await this.usersCollection.doc(id).get();
        if (!doc.exists)
            throw new IllegalArgumentException("unable to update user that does not exist");
        return doc.ref.set(change, { merge: true });
    }
    async followUser(id, followerId) {
        return this.usersCollection.doc(followerId).update("following", FieldValue.arrayUnion(id));
    }
    async unfollowUser(id, followerId) {
        return this.usersCollection.doc(followerId).update("following", FieldValue.arrayRemove(id));
    }
    async getDocumentByField(field, value) {
        const query = this.usersCollection.where(field, "==", value).limit(1);
        const snapshot = await query.get();
        return snapshot.docs[0];
    }
}
function toUser(snapshot) {
    if (!(snapshot === null || snapshot === void 0 ? void 0 : snapshot.exists))
        return undefined;
    return deserializeUser(snapshot.id, snapshot.data());
}
